import Qs from 'qs';

/**
 * Converts an object to query string, filtering out empty, null, and undefined values.
 */
export const addQueryParam = (obj: Record<string, unknown>) => {
  const filteredObj = Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) => value !== undefined && value !== null && value !== ''
    )
  );
  return Qs.stringify(filteredObj);
};
